import { render, staticRenderFns } from "./PluginGenericobjectAlim.vue?vue&type=template&id=3ce1a8c0"
import script from "./PluginGenericobjectAlim.vue?vue&type=script&lang=js"
export * from "./PluginGenericobjectAlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports